import tt from './pages/Timetable/store.js'
import ct from './pages/Contact/store.js'
import rpk from './pages/Repack/store.js'
import bookmark from './stores/bookmark.js'

export default {
  namespaced: true,
  modules: {
    bookmark: bookmark,
    tt: tt,
    ct: ct,
    rpk: rpk
  },
  state () {
    return {}
  },
  getters: {},
  mutations: {},
  actions: {}
}



// WEBPACK FOOTER //
// ./src/app/store.js